// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"ee00c67d","702":"395881f7"}[chunkId] + ".chunk.css";
};